document.addEventListener("DOMContentLoaded", function () {
  
if (document.querySelector('.js-fas-mainvisual')) {
   let mvslide = new Splide(".js-fas-mainvisual", {
    type: "loop",
    rewind: false,
    focus: "center",
    perPage: 1.5,
    gap: 12,
    pagination: false,
    arrows: true,
      breakpoints: {
      720:{
        perPage: 1,
        arrows: true
      }
    }
  });

  mvslide.mount();
}
 
});
